import { render } from "./InformationHeaderComponent.vue?vue&type=template&id=669537cc&scoped=true"
import script from "./InformationHeaderComponent.vue?vue&type=script&lang=js"
export * from "./InformationHeaderComponent.vue?vue&type=script&lang=js"

import "./InformationHeaderComponent.vue?vue&type=style&index=0&id=669537cc&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-669537cc"]])

export default __exports__